import { Typography, useMediaQuery } from '@mui/material';
import React, { FC } from 'react';
import { APIS } from '../../../../lib/constants/apis';
import ApplicationHeading from '../../../../pages/private/online-antrag/application-heading/ApplicationHeading';
import CreateForm from '../../../ui-component/form-component/create-form/CreateForm';

// import schemas
import Schema from '../../../../lib/paths/person_FULL_Paths.json';
const P = Schema.attributes;

const PersonDaten: FC<{
	formValue: any;
	updateFunction: (_key: string, _value: any) => void;
	personDatenError: any;
}> = ({ formValue, updateFunction, personDatenError }) => {
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	return (
		<>
			<ApplicationHeading title='Ihr Profil' description='' />
			<Typography variant='body1' mb={2}>
				Bitte füllen Sie die Daten in Ihrem Profil vollständig aus.{' '}
				<strong>Der Registrierungslink für Ihre Anmeldung hier im Portal wird an die hier angegebene E-Mail-Adresse versendet.</strong>
			</Typography>

			<CreateForm
				formValues={formValue}
				formStruc={formStruc(isSmallScreen)}
				updateFormValuesFunc={updateFunction}
				formErrors={personDatenError}
				api={APIS.Person}
			/>
		</>
	);
};

export default PersonDaten;

const formStruc = (isSmallScreen: boolean) => {
	return [
		{
			fields: [P.Personenbezogene_Daten_Anrede, P.Personenbezogene_Daten_Titel],
			userProps: { direction: isSmallScreen ? 'column' : '', columnToDivide: isSmallScreen ? 1 : 2, columnGap: '1rem' },
		},
		{
			fields: [P.Personenbezogene_Daten_Vorname, P.Personenbezogene_Daten_Nachname],
			userProps: { columnToDivide: 2 },
		},
		{
			fields: [P.Kontaktdaten_E_Mail, P.Kontaktdaten_Telefon],
			userProps: { columnToDivide: 2 },
		},
	];
};
